// Entry point for the build script in your package.json

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

import "./features/menu";
import "./features/news";
import "./features/slideshow";
